import { Box, Typography } from "@mui/material";
import { FancyIcon, WfIconContentInfoRegular } from "@WahooFitness/redesignr";

function HowWeCalculateDrawer({ infoText }: { infoText: string }) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={2} pb={4} gap={3}>
      <FancyIcon icon={<WfIconContentInfoRegular />} size="medium" color="info" />
      <Typography variant="prose-base">{infoText}</Typography>
    </Box>
  );
}

export default HowWeCalculateDrawer;
